<template>
  <div class="container margin_60_55">
    <div class="row  mt-5">
      <div class="col-lg-9" v-if="blogInfo">
        <div class="bloglist singlepost">
          <h1>{{ blogInfo.Title }}</h1>
          <div class="postmeta">
            <ul>
              <li>
                <i class="icon_clock_alt"></i>
                {{
                  new Date(blogInfo.UpdateDate)
                    .toLocaleString()
                    .replace(",", "")
                    .replace(/:.. /, " ")
                }}
              </li>
              <li>
                <i class="icon_pencil-edit"></i>
                {{ blogInfo.UserName }}
              </li>
            </ul>
          </div>
          <!-- /post meta -->
          <div class="post-content">
            <div class="dropcaps">
              <p v-html="blogInfo.Body"></p>
            </div>
          </div>
          <!-- /post -->
        </div>
        <!-- /single-post -->
      </div>
      <!-- /col -->

      <aside class="col-lg-3 bg-white h-100" >
        <!-- /widget -->
        <div class="widget">
          <div class="widget-title">
            <h4>Recent Posts</h4>
          </div>
          <ul class="comments-list" v-if="bloglist">
            <li  v-for="(bloglistitem, index) in bloglist"
            :key="index">
              
              <small>{{ bloglistitem.UserName }}</small>
              <h3>
                  <a href="javascript:void(0)" @click="reloadToDetailsPg(bloglistitem.ID)"> {{ bloglistitem.Title }}</a>
                
                <!-- <router-link
                  :to="{
                    name: 'BlogDetails',
                    params: { blogId: bloglistitem.ID },
                  }"
                  >{{ bloglistitem.Title }}</router-link
                > -->
              </h3>
            </li>
          </ul>
        </div>

        <!-- /widget -->
        <!-- <div class="widget">
          <div class="widget-title">
            <h4>Popular Tags</h4>
          </div>
          <div class="tags">
            <a href="#">Information tecnology</a>
            <a href="#">Students</a>
            <a href="#">Community</a>
            <a href="#">Carreers</a>
            <a href="#">Literature</a>
            <a href="#">Seminars</a>
          </div>
        </div> -->
        <!-- /widget -->
      </aside>
      <!-- /aside -->
    </div>
    <!-- /row -->
  </div>
</template>
<script>
import BlogService from '../services/blog-service'
import _ from 'lodash'
export default {
  name: 'BlogDetails',
  data() {
    return {
      blogInfo: [],
      bloglist: [],
    }
  },
  watch: {
    $route () {
      this.getBlogInfo(this.$route.params.Id)
    }
  },
  mounted() {
    this.getBlogInfo(this.$route.params.Id)
    this.getBlogs()
  },
  methods: {
    getBlogInfo(Id) {
      BlogService.getBlogInformation(Id).then((response) => {
        this.blogInfo = response.data.Object.blog
      }),
      (error) => {
        console.log(error)
      }
    },
    getBlogs() {
      BlogService.getBlogList().then((response) => {
        this.bloglist = _.orderBy(response.data.Object.blogs).slice(0, 3)
      }),
      (error) => {
        console.log(error)
      }
    },
    reloadToDetailsPg(blogId){
      this.$router.push({ name: 'BlogDetails', params: { Id: blogId } }, )
      this.getBlogInfo(blogId)
    }
  },
}
</script>
